const translateReuse = {
  na: 'N / A',
};

export default translateReuse;
